import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormGroup, FormLabel, IconButton, MenuItem, Modal, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import TitleText from './TitleText'
import CancelIcon from '@mui/icons-material/Cancel';
import ButtonStyled from './ButtonStyled';

import CheckIcon from '@mui/icons-material/Check';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddIcon from '@mui/icons-material/Add';

import ButtonAdd from './ButtonAdd';
import { memo } from 'react';

const formLabelStyle = {color: '#A1A1A1', fontWeight:'bold', fontSize:{xs: '1rem',}, display: 'flex', pb:'0.6rem' };
const formInput = { display: "flex", flexDirection: "column", width: "100%", alignItems: "left" }


function CharacteristicDependencyRuleForm({
    dependencyRules,
    setCurrSelectedRule,
    currSelectedRule,
    updateCurrSelectedRule,
    onSelectRuleIfItem,
    onNewDependency,
    onSelectedThen,
    primaryCharacteristicValues,
    setDeleteContext,
    setOpenDeleteModal,
    handleCreateRule,
    renderRuleCharacteristicOptions
}) {
    const renderRuleValues = useMemo(() => {
        if (!currSelectedRule?.if?.length || !renderRuleCharacteristicOptions?.length) return []

        const selectedCharacteristicIds = new Set(
            currSelectedRule.if.map(item => item.characteristicId)
        );

        const processedValues = renderRuleCharacteristicOptions
            .filter(char => selectedCharacteristicIds.has(char.characteristicId))
            .flatMap(char =>
                char.values.map(value => ({
                    characteristicId: char.characteristicId,
                    characteristicName: char.characteristicName,
                    valueName: value
                }))
            );

        return processedValues;
    }, [currSelectedRule?.if, renderRuleCharacteristicOptions])

    const renderRuleThenValues = useMemo(() => {
        if (!currSelectedRule?.then?.length || !renderRuleCharacteristicOptions?.length) return []

        const selectedCharacteristicIds = new Set(
            currSelectedRule.then.map(item => item.characteristicId)
        );

        const processedValues = renderRuleCharacteristicOptions
            .filter(char => selectedCharacteristicIds.has(char.characteristicId))
            .flatMap(char =>
                char.values.map(value => ({
                    characteristicId: char.characteristicId,
                    characteristicName: char.characteristicName,
                    valueName: value
                }))
            );

        return processedValues;
    }, [currSelectedRule?.then, renderRuleCharacteristicOptions])

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "100%",
                gap: 4
            }}
        >
            <FormGroup>
                <Box 
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <FormLabel sx={formLabelStyle}>CREACIÓN DE REGLAS DE DEPENDENCIAS</FormLabel>
                    <ButtonAdd onClick={() => {handleCreateRule()}} title={"Crear Nueva Regla"} />
                </Box>
            </FormGroup>
            
            <Box
                sx={{ 
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    p: 0,
                    gap: 4
                }}
            >
                <Select
                    sx={{
                        width: "100%"
                    }}
                    value={currSelectedRule._id || ""}
                    onChange={(e) => {
                        const targetId = e.target.value
                        setCurrSelectedRule(
                            dependencyRules.find(r => r._id === targetId)
                        )
                    }}
                >
                    <MenuItem value={""} disabled>Selecciona la Regla</MenuItem>
                    {dependencyRules && dependencyRules.map((item, index) => (
                        <MenuItem key={index} value={item._id}>
                            {item.title}
                        </MenuItem>
                    ))}
                </Select>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                        border: 1,
                        borderRadius: ".25rem",
                        borderColor: "#A1A1A1",
                        p: 2,
                        gap: 2
                    }}
                >
                    {currSelectedRule && (<>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%",
                                gap: 2
                            }}
                        >
                            <FormGroup title='rule_title' sx={{ width: "100%", gap: 2}}>
                                <FormLabel>Nombre de la Regla</FormLabel>
                                <TextField
                                    value={currSelectedRule.title}
                                    onChange={(e) => {updateCurrSelectedRule(e, "title")}}
                                />
                            </FormGroup>
                            <DeleteOutlinedIcon 
                                sx={{
                                    color:'red', 
                                    fontSize:{xs:'1.13rem', md:'1.88rem'}, 
                                    '&:hover': {cursor: "pointer"} 
                                }}
                                onClick={() => {
                                    setDeleteContext({
                                        type: "rule",
                                        payload: currSelectedRule
                                    });
                                    setOpenDeleteModal(true)
                                }}
                            />
                        </Box>

                        <FormGroup
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                            }}
                        >
                            <FormLabel sx={{color: "#FC581F"}}>Si</FormLabel>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                    p: 2,
                                    border: 1,
                                    borderRadius: "0.25rem",
                                    borderColor: "#A1A1A1"
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                        p: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            gap: 2,
                                        }}
                                    >
                                        <Box sx={{ ...formInput }}>
                                            <FormLabel>VALORES PRINCIPALES</FormLabel>
                                            <Select
                                                multiple
                                                value={currSelectedRule.primary || ""}
                                                onChange={(e) => updateCurrSelectedRule(e, "primary")}
                                                renderValue={(value) => {
                                                    if (value.length === 0) {
                                                        return "Selecciona el Valor"
                                                    }
                                                    
                                                    // Render only 30 characters of the value
                                                    const shownValues = value.join(", ")
                                                    return shownValues.length > 30 ? 
                                                        `${shownValues.slice(0, 30)}...` : 
                                                        shownValues
                                                }}
                                            >
                                                <MenuItem value={""} disabled>Selecciona el Valor</MenuItem>
                                                {primaryCharacteristicValues.map((item, index) => (
                                                    <MenuItem key={index} value={item.valueName}>
                                                        {item.valueName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>

                                        <Box
                                            sx={{ ...formInput }}
                                        >
                                            <FormLabel>CARACTERÍSTICA</FormLabel>
                                            <Select
                                                value={currSelectedRule.if || ""}
                                                onChange={(e) => {
                                                    // console.log("CHAR", e.target.value);
                                                    onSelectRuleIfItem({ 
                                                        mode: "characteristic", 
                                                        payload: {
                                                            characteristicId: e.target.value
                                                        } 
                                                    })
                                                }}
                                            >
                                                <MenuItem value={""} disabled>Selecciona la Característica</MenuItem>
                                                {renderRuleCharacteristicOptions.map((item, index) => (
                                                    <MenuItem key={index} value={item.characteristicId}>
                                                        {item.characteristicName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            maxHeight: "30rem",
                                            width: "100%",
                                            overflowY: 'scroll',
                                            gap: 2,
                                            p: 2,
                                            border: 1,
                                            borderRadius: "0.25rem",
                                            borderColor: "#A1A1A1"
                                        }}
                                    >  
                                        {
                                            currSelectedRule.if.map((item, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "space-between",
                                                        flexWrap: "nowrap",
                                                        px: 2
                                                    }}
                                                >
                                                    {item.characteristicName}
                                                    <DeleteOutlinedIcon 
                                                        sx={{
                                                            color:'red', 
                                                            fontSize:{xs:'1.13rem', md:'1.88rem'}, 
                                                            '&:hover': {cursor: "pointer"} 
                                                        }}
                                                        onClick={() => {
                                                            setDeleteContext({
                                                                type: "characteristic-if",
                                                                payload: item
                                                            });
                                                            setOpenDeleteModal(true)
                                                        }}
                                                    />
                                                </Box>
                                            ))
                                        }
                                    </Box>
                                    
                                    <FormGroup>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 2,
                                                width: "100%"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    width: "100%"
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <FormLabel>VALORES</FormLabel>
                                                    <Select
                                                        value={currSelectedRule.if || ""}
                                                        onChange={(e) => {
                                                            // console.log("VAL", e.target.value);
                                                            const targetItem = renderRuleValues.find(
                                                                v => v.valueName === e.target.value
                                                            )
                                                            onSelectRuleIfItem({
                                                                mode: "value",
                                                                payload: {
                                                                    characteristicId: targetItem.characteristicId,
                                                                    valueName: targetItem.valueName
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <MenuItem value={""} disabled>Selecciona el Valor</MenuItem>
                                                        {renderRuleValues.filter(item => {
                                                            return !currSelectedRule.if.some(
                                                                ruleItem =>
                                                                ruleItem.characteristicId === item.characteristicId &&
                                                                ruleItem.values.includes(item.valueName)
                                                            );
                                                            }).map((item, index) => (
                                                            <MenuItem
                                                                key={index}
                                                                value={item.valueName}
                                                            >
                                                                {item.valueName} ({item.characteristicName})
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    maxHeight: "30rem",
                                                    width: "100%",
                                                    overflowY: 'scroll',
                                                    gap: 2,
                                                    p: 2,
                                                    border: 1,
                                                    borderRadius: "0.25rem",
                                                    borderColor: "#A1A1A1"
                                                }}
                                            >  
                                                {
                                                    currSelectedRule.if.map((item, index) => (
                                                        item.values.map((val, index) => {
                                                            // console.log("V", val)
                                                            return (
                                                                <Box
                                                                    key={index}
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        justifyContent: "space-between",
                                                                        flexWrap: "nowrap",
                                                                        px: 2,
                                                                    }}
                                                                >
                                                                    {val} ({item.characteristicName})
                                                                    <DeleteOutlinedIcon 
                                                                        sx={{
                                                                            color:'red', 
                                                                            fontSize:{xs:'1.13rem', md:'1.88rem'}, 
                                                                            '&:hover': {cursor: "pointer"} 
                                                                        }}
                                                                        onClick={() => {
                                                                            setDeleteContext({
                                                                                type: "value-if",
                                                                                payload: {
                                                                                    characteristicId: item.characteristicId,
                                                                                    valueName: val
                                                                                }
                                                                            });
                                                                            setOpenDeleteModal(true)
                                                                        }}
                                                                    />
                                                                </Box>
                                                            )
                                                        })
                                                    ))
                                                }
                                            </Box>
                                        </Box>
                                    </FormGroup>
                                </Box>
                            </Box>

                            <FormLabel sx={{color: "#FC581F"}}>Entonces</FormLabel>
                            {currSelectedRule && currSelectedRule.then.map((currThen, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                        p: 2,
                                        border: 1,
                                        borderRadius: "0.25rem",
                                        borderColor: "#A1A1A1"
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-end",
                                            width: "100%"
                                        }}
                                    >
                                        <DeleteOutlinedIcon 
                                            sx={{
                                                color:'red', 
                                                fontSize:{xs:'1.13rem', md:'1.88rem'}, 
                                                '&:hover': {cursor: "pointer"} 
                                            }}
                                            onClick={() => {
                                                setDeleteContext({
                                                    type: "then",
                                                    payload: {
                                                        index: index
                                                    }
                                                });
                                                setOpenDeleteModal(true)
                                            }}
                                        />
                                    </Box>
                                    <FormLabel>CARACTERÍSTICA</FormLabel>
                                    <Select
                                        sx={{ width: "100%" }}
                                        value={currThen.characteristicId || ""}
                                        onChange={(e) => {
                                            // console.log("OPTS", renderRuleCharacteristicOptions)
                                            // console.log("THEN CHAR", e.target.value);
                                            onSelectedThen({
                                                payload: {
                                                    index: index,
                                                    characteristicId: e.target.value,
                                                }
                                            })
                                            // console.log(currThen)
                                        }}
                                    >
                                        <MenuItem value={""} disabled>Selecciona la Característica</MenuItem>
                                        {renderRuleCharacteristicOptions && renderRuleCharacteristicOptions.filter(char => {
                                            return !currSelectedRule.if.some(
                                                ruleChar => ruleChar.characteristicId === char.characteristicId
                                            ); 
                                            }).map((item, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={item.characteristicId}
                                                >
                                                    {item.characteristicName}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                    
                                    {currThen.characteristicId && (
                                        <>
                                            <FormLabel>VALORES</FormLabel>
                                            <Select
                                                sx={{ width: "100%" }}
                                                value={currThen.values || ""}
                                                onChange={(e) => {
                                                    // console.log("THEN VAL", e.target.value);
                                                    onSelectedThen({
                                                        payload: {
                                                            index: index,
                                                            characteristicId: currThen.characteristicId,
                                                            valueName: e.target.value
                                                        }
                                                    })
                                                    // console.log(currThen)
                                                }}
                                            >
                                                <MenuItem value={""} disabled>Selecciona el Valor</MenuItem>
                                                {
                                                    currThen.characteristicId && (
                                                        renderRuleCharacteristicOptions
                                                        .find(char => 
                                                            char.characteristicId === currThen.characteristicId)?.
                                                        values?.map((value, vindex) => (
                                                            <MenuItem key={vindex} value={value}>
                                                                {value}
                                                            </MenuItem>
                                                        ))
                                                    )
                                                }   
                                            </Select>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    maxHeight: "30rem",
                                                    width: "100%",
                                                    overflowY: 'scroll',
                                                    gap: 2,
                                                    p: 2,
                                                    border: 1,
                                                    borderRadius: "0.25rem",
                                                    borderColor: "#A1A1A1"
                                                }}
                                            >  
                                                {
                                                    currThen.values.map((val, index) => {
                                                        // console.log("V", val)
                                                        return (
                                                            <Box
                                                                key={index}
                                                                sx={{
                                                                    display: "flex",
                                                                    flexDirection: "row",
                                                                    justifyContent: "space-between",
                                                                    flexWrap: "nowrap",
                                                                    px: 2,
                                                                }}
                                                            >
                                                                {val.valueName}
                                                                <DeleteOutlinedIcon 
                                                                    sx={{
                                                                        color:'red', 
                                                                        fontSize:{xs:'1.13rem', md:'1.88rem'}, 
                                                                        '&:hover': {cursor: "pointer"} 
                                                                    }}
                                                                    onClick={() => {
                                                                        setDeleteContext({
                                                                            type: "then",
                                                                            payload: {
                                                                                characteristicId: currThen.characteristicId,
                                                                                valueName: val.valueName
                                                                            }
                                                                        });
                                                                        setOpenDeleteModal(true)
                                                                    }}
                                                                />
                                                            </Box>
                                                        )
                                                    })
                                                }
                                            </Box>
                                        </>

                                    )}
                                </Box>
                            ))}
                            
                            <ButtonStyled 
                                text={(<><AddIcon /> Agregar Dependencia</>)} 
                                handleClick={onNewDependency}
                            />
                        </FormGroup>
                    </>)}
                </Box>
            </Box>
        </Box>
    )
}

export default CharacteristicDependencyRuleForm